/* istanbul ignore file */
import { SerializedData } from "bernie-core";
import { Store } from "bernie-plugin-mobx";
import { observable, action } from "mobx";

import { Logger } from "bernie-logger";

export class ThemeSelectorStore extends Store {
  public constructor(state: SerializedData, logger: Logger) {
    /* istanbul ignore next */
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @observable
  public activeTheme = "beach";

  @action
  public updateActiveTheme(newTheme: string) {
    this.activeTheme = newTheme;
  }
}
